export const onServiceWorkerUpdateReady = () => {
  window.location.reload(true);
};

export const onServiceWorkerActive = () => {
  if (navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    });
  }
};